/* istanbul ignore file */
import { getUser } from 'services/auth';
import { ENUM_TIPO_PERFIL } from 'utils/permissao';
import { fetchGetDadosCadastrais } from 'store/fetchActions/fetchDadosCadastrais';
import { fetchGetAtendente } from 'store/fetchActions/fetchAtendente';

export const fetchGetUserDataByDocumento = (documentoUser, atendenteLogado, contribuinteLogado) => dispatch => {
  return new Promise((resolve, reject) => {
    if (atendenteLogado) resolve(atendenteLogado);
    if (contribuinteLogado) resolve(contribuinteLogado);
    else {
      const user = getUser();
      const documento = documentoUser ? documentoUser : user?.cpf_cnpj;

      if (!documento) {
        reject(documento);
        return;
      }
      if (user?.profile === ENUM_TIPO_PERFIL.CONTRIBUINTE) {
        dispatch(fetchGetDadosCadastrais()).then(res => resolve(res));
      }
      if (user?.profile !== ENUM_TIPO_PERFIL.CONTRIBUINTE) {
        dispatch(fetchGetAtendente(documento, user)).then(res => resolve(res));
      }
    }
  });
};
